import type { SortAlgorithm, SortController } from "./SortController";
import { BubbleSortController } from "./BubbleSortController";
import { SelectionSortController } from "./SelectionSortController";
import { InsertionSortController } from "./InsertionSortController";

/**
 * The one place that knows the mapping from a level's `algorithm` field to
 * a concrete SortController (Phase 08), mirroring createSearchController's
 * role for Searching. Adding a fourth sorting algorithm later means adding
 * one branch here and one new controller class — GameRuntime itself never
 * needs to change.
 */
export function createSortController(
  algorithm: SortAlgorithm,
  values: number[],
  sortDirection: "ascending" | "descending",
): SortController {
  if (algorithm === "selection-sort") {
    return new SelectionSortController(values, sortDirection);
  }
  if (algorithm === "insertion-sort") {
    return new InsertionSortController(values, sortDirection);
  }
  return new BubbleSortController(values, sortDirection);
}
